import { render, staticRenderFns } from "./EmprestimoForm.vue?vue&type=template&id=6882a429"
import script from "./EmprestimoForm.vue?vue&type=script&lang=js"
export * from "./EmprestimoForm.vue?vue&type=script&lang=js"
import style0 from "./EmprestimoForm.vue?vue&type=style&index=0&id=6882a429&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports